import { register } from "async-ops";
import {  callMvcApiblob } from "../../../call-web-api";
export const EXPORT_THOUGHTSPOT_LIVEBOARD = "EXPORT_THOUGHTSPOT_LIVEBOARD";

export const service = async (requestData) => {
  const options = {
    url: "/api/AISummary/export-thoughtspot-liveboard",
    method: "POST",
    body: JSON.stringify(requestData),
    headers: {
      'Content-Type': 'application/json'
    }
  };
  const response = await callMvcApiblob(options); 
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(EXPORT_THOUGHTSPOT_LIVEBOARD, service, mock);
